@use '@fukuri-admins/ui/layout' as *;

.timeInput {
  display: flex;
  align-items: center;
  width: 130px;
  min-height: 40px;
  background: background('Primary');
  border-radius: borderRadius('lg');
  border: 1px solid border('Quaternary');
  padding: spacing('8') spacing('12');

  @include typography('Jp/14_W3');
  color: text('High');
  cursor: pointer;

  &:hover:not(:disabled) {
    background: background('Overlay_Bl_5');
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }

  &:disabled {
    color: text('Disabled');
    cursor: not-allowed;
  }
}
